import t from"react";import e from"./container.module.less.js";const n=({testId:n="container-component",as:o,children:r,...a})=>{const c=o||"div";return t.createElement(c,{"data-testid":n,className:e.container,...a},r)};export{n as ContainerComponent};
//# sourceMappingURL=container.component.js.map
